// // middleware/auth.js
// export default async function ({ app }) {
//     // console.log(app.mixins[0].methods.checkToken);
//     await app.mixins[0].methods.checkToken();
// }
